import moment, { Moment } from 'moment';

export default class TimeUtils {
  public static getDayInSeconds(): number {
    return 60 * 60 * 24;
  }

  /* This method returns distance from current moment in UTC to a chosen timestamp that also should be in UTC */
  public static getDifferenceFromUtcNow(timestampInUtc: number): number {
    return moment.utc().valueOf() - timestampInUtc;
  }

  /* This method checks if chosen timestamp (UTC) in in the last X hours from this moment  */
  public static isTimestampInLastXHours(timestampInUtc: number, numberOfHours: number): boolean {
    const momentToCompareWith = numberOfHours * 60 * 60 * 1000;
    return this.getDifferenceFromUtcNow(timestampInUtc) <= momentToCompareWith;
  }

  public static getMoment(value?): any {
    return value ? moment(value) : moment();
  }

  public static getUtcMoment(timestampInUtc: number): Moment {
    return moment.utc();
  }

  public static getSubtractDate(amount, typeDate, date?): Moment {
    return date ? moment(date).subtract(amount, typeDate) : moment().subtract(amount, typeDate);
  }

  public static getFromattedSubtractDate(amount, typeDate, date?): string {
    return date
      ? moment(date).subtract(amount, typeDate).format('YYYY-MM-DD')
      : moment().subtract(amount, typeDate).format('YYYY-MM-DD');
  }

  public static getFormattedDate(value?): string {
    return value ? moment(value).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
  }

  public static getUnixFormattedDate(value): string {
    return moment.unix(value).format('YYYY-MM-DD');
  }

  public static getFormattedDateWithTime(value): string {
    return moment(value).format('YYYY-MM-DD HH:mm');
  }

  public static getDateToDate(date?): Date {
    return date ? moment(date).toDate() : moment().toDate();
  }

  public static getDateStartOf(typeDate, date?): Date {
    return date ? moment(date).startOf(typeDate).toDate() : moment().startOf(typeDate).toDate();
  }

  public static getMomentStartOf(typeDate, date?): Moment {
    return date ? moment(date).startOf(typeDate) : moment().startOf(typeDate);
  }

  public static getDateAddEndOf(date, addDate, typeAddDate, typeDate): Date {
    return moment(date).add(addDate, typeAddDate).endOf(typeDate).toDate();
  }

  public static getFormattedDateAdd(date, addDate, typeAddDate): string {
    return moment(date).add(addDate, typeAddDate).format('YYYY-MM-DD');
  }

  public static getDateAddtoDate(addDate, typeAddDate, date?): Date {
    return date ? moment(date).add(addDate, typeAddDate).toDate() : moment().add(addDate, typeAddDate).toDate();
  }

  public static getDateAddValueOf(addDate, typeAddDate, date?): number {
    return date ? moment(date).add(addDate, typeAddDate).valueOf() : moment().add(addDate, typeAddDate).valueOf();
  }

  public static getDateDiff(date_1, date_2, typeDate): number {
    return moment(date_1).diff(moment(date_2), typeDate);
  }

  public static getDateIsoFormat(date): string {
    return moment(date).toISOString();
  }

  public static isAfterDate(date, afterDate): boolean {
    return moment(date).isAfter(moment(afterDate));
  }

  public static getMomentFormatted(date, format): Moment {
    return moment(date, format);
  }

  public static getDateUtcFormat(date, timeZone, isChanged): Moment {
    return moment.utc(date * 1000).utcOffset(timeZone, isChanged);
  }

  public static getDuration(value): moment.Duration {
    return moment.duration(value);
  }
}
